import { Middleware } from 'redux';
import { userPromoCodeService } from 'services/user-promo-code.service';
import { USER_SET } from 'store/action-types/user.action-types';
import { takePendingReferralCode } from 'utils/promo-code';

export const referralServiceMiddleware: Middleware = () => {
  return (next) => (action) => {
    if (action.type === USER_SET && action.data?.role && action.data.role !== 'guest') {
      const referralCode = takePendingReferralCode();

      if (referralCode) {
        userPromoCodeService.registerFromInviteLink(referralCode);
      }
    }

    return next(action);
  };
};
